import { render, staticRenderFns } from "./DeliveryInformation.vue?vue&type=template&id=990f8646&scoped=true"
import script from "./DeliveryInformation.vue?vue&type=script&lang=ts"
export * from "./DeliveryInformation.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryInformation.vue?vue&type=style&index=0&id=990f8646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.27_css-loader@6.11.0_webpack@5.92.0_esbuild@0._a350796feef9738eb472af7b4bb320e8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990f8646",
  null
  
)

export default component.exports